import { gql } from "@apollo/client";

export const LOGIN_SCREEN_DETAILS = gql`
query allLoginScreenDetails {
  allLoginScreenDetails(
    orderBy: INDEX_ASC
    condition: {isNeed: true}
    filter: {deletedAt: {isNull: true}}
  ) {
    totalCount
    nodes {
      avatarUrl
      colorCode
      role
      ldId
      index
    }
  }
}
`;